// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getMediaSurveys as listMediaSurveysAPI,
    getMediaSurvey as getMediaSurveyAPI,
    addMediaSurvey as addMediaSurveyAPI,
    updateMediaSurvey as updateMediaSurveyAPI,
    deleteMediaSurvey as deleteMediaSurveyAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { mediaSurveysApiResponseError, mediaSurveysApiResponseSuccess } from './actions';
import { MediaSurveysActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getMediaSurvey({ payload: { id } }) {
    try {
        const response = yield call(getMediaSurveyAPI, id );
        const mediaSurveyItem = response.data.data;
        yield put(mediaSurveysApiResponseSuccess(MediaSurveysActionTypes.GET_MEDIA_SURVEY, mediaSurveyItem));
    } catch (error) {
        yield put(mediaSurveysApiResponseError(MediaSurveysActionTypes.GET_MEDIA_SURVEY, error));
    }
}

function* addMediaSurvey({payload:mediaSurvey}){
    try{
        const response = yield call(addMediaSurveyAPI,{...mediaSurvey})
        const mediaSurveyItem = response.data
        yield put(mediaSurveysApiResponseSuccess(MediaSurveysActionTypes.ADD_MEDIA_SURVEY,mediaSurveyItem))
    } catch(error){
        yield put(mediaSurveysApiResponseError(MediaSurveysActionTypes.ADD_MEDIA_SURVEY,error))
    }
}

function* updateMediaSurvey({payload:mediaSurvey}){
    try{
        const response = yield call(updateMediaSurveyAPI,{...mediaSurvey})
        const mediaSurveyItem = response.data.data
        yield put(mediaSurveysApiResponseSuccess(MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY,mediaSurveyItem))
    }catch(error){
        yield put(mediaSurveysApiResponseError(MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY,error))
    }
}
function* deleteMediaSurvey({payload:{id}}){
    try{
        const response = yield call(deleteMediaSurveyAPI,id)
        const mediaSurveyItem = response.data.id
        yield put(mediaSurveysApiResponseSuccess(MediaSurveysActionTypes.DELETE_MEDIA_SURVEY,mediaSurveyItem))
    }catch(error){
        yield put(mediaSurveysApiResponseError(MediaSurveysActionTypes.DELETE_MEDIA_SURVEY,error))
    }
}

/**
 * List contactos
 */
function* listMediaSurveys({payload:params}) {
    try {
        const response = yield call(listMediaSurveysAPI, { ...params });
        const listaMediaSurveys = response.data.data;
        yield put(mediaSurveysApiResponseSuccess(MediaSurveysActionTypes.LIST_MEDIA_SURVEYS, listaMediaSurveys));
    } catch (error) {
        yield put(mediaSurveysApiResponseError(MediaSurveysActionTypes.LIST_MEDIA_SURVEYS, error));
    }
}


export function* watchGetMediaSurvey(): any {
    yield takeEvery(MediaSurveysActionTypes.GET_MEDIA_SURVEY, getMediaSurvey);
}

export function* watchListMediaSurveys(): any {
    yield takeEvery(MediaSurveysActionTypes.LIST_MEDIA_SURVEYS, listMediaSurveys);
}

export function* watchAddMediaSurvey():any{
    yield takeEvery(MediaSurveysActionTypes.ADD_MEDIA_SURVEY,addMediaSurvey)
}
export function* watchUpdateMediaSurvey():any{
    yield takeEvery(MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY,updateMediaSurvey)
}
export function* watchDeleteMediaSurvey():any{
    yield takeEvery(MediaSurveysActionTypes.DELETE_MEDIA_SURVEY,deleteMediaSurvey)
}


function* mediaSurveysSaga(): any {
    yield all([
        fork(watchGetMediaSurvey),
        fork(watchListMediaSurveys),
        fork(watchAddMediaSurvey),
        fork(watchUpdateMediaSurvey),
        fork(watchDeleteMediaSurvey),
    ]);
}

export default mediaSurveysSaga;
